var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.readOnly
    ? _c("material-input", {
        attrs: { "read-only": "", label: _vm.label, type: "email" },
        model: {
          value: _vm.toList,
          callback: function ($$v) {
            _vm.toList = $$v
          },
          expression: "toList",
        },
      })
    : _c(
        "material-input",
        { attrs: { id: "select-email-field", label: _vm.computedLabel } },
        [
          _c("select2", {
            ref: "select",
            attrs: {
              value: _vm.toList,
              data: _vm.emailList,
              "format-data": _vm.formatData,
              options: _vm.selectOptions,
            },
            on: { change: _vm.handleChange },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }